import { render, staticRenderFns } from "./SpecialCharacterRemoverPage.vue?vue&type=template&id=0afdc7d4"
import script from "./SpecialCharacterRemoverPage.vue?vue&type=script&lang=js"
export * from "./SpecialCharacterRemoverPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports